import urls from "frontend/routes/urls"

export default route => urls[route.name].props(route)
